import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=55a8dd92&"
import script from "./EventDetails.vue?vue&type=script&lang=js&"
export * from "./EventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports